import { FC } from 'react';
import { useField } from 'formik';
import Input, { PasswordInputProps } from '@/components/ui/PasswordInput/PasswordInput';

interface FormikPasswordInputProps extends Omit<PasswordInputProps, 'value' | 'onChange' | 'errorMessage' | 'touched'> {
	name: string;
}

const FormikPasswordInput: FC<FormikPasswordInputProps> = ({ name, ...props }) => {
	const [{ value, onBlur }, { error, touched }, { setValue }] = useField(name);

	return (
		<Input
			{...props}
			name={name}
			onBlur={onBlur}
			value={value}
			onChange={newValue => setValue(newValue)}
			errorMessage={error}
			touched={touched}
		/>
	);
};

export default FormikPasswordInput;
